import PendoIconButton from '../icon-button/pendo-icon-button.vue.js';

var GroupCell = {
  name: 'GroupCell',
  inject: ['$table'],
  props: {
    row: Object,
    rowIndex: Number
  },
  computed: {
    expanded() {
      return Boolean(this.$table.groupExpandedMap[this.row[this.$table.rowKey]]);
    }
  },
  methods: {
    toggleRowExpand() {
      this.$table.toggleRowGroupExpand(this.row);
    }
  },
  render(createElement) {
    const {
      row,
      rowIndex,
      $table,
      expanded,
      toggleRowExpand
    } = this;
    let children = row[$table.rowKey];
    if ($table.$scopedSlots && $table.$scopedSlots.groupRow) {
      children = $table.$scopedSlots.groupRow({
        row,
        rowIndex,
        toggleRowExpand
      });
    }
    function renderExpandAction() {
      if ($table.groupConfig.expandable) {
        return createElement('div', {
          class: ['pendo-table__group-expand', {
            'is-expanded': expanded
          }],
          style: {
            height: `${row.height}px`
          }
        }, [createElement(PendoIconButton, {
          props: {
            icon: 'chevron-up',
            tooltip: expanded ? 'Collapse' : 'Expand'
          },
          attrs: {
            size: 'mini'
          },
          on: {
            click: toggleRowExpand
          }
        })]);
      }
      return null;
    }
    return createElement('td', {
      class: 'pendo-table__column pendo-table__column--group',
      attrs: {
        colspan: $table.tableColumns.length
      },
      style: {
        height: `${row.height}px`
      }
    }, [createElement('div', {
      class: 'pendo-table__cell'
    }, [renderExpandAction(), createElement('div', {}, children)])]);
  }
};

export { GroupCell as default };
//# sourceMappingURL=group-cell.js.map
